module.exports = __webpack_public_path__ + "img/img_internet_install_cost.2ab03cce.png";